import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, filter, switchMap, take } from "rxjs/operators";
import { BASE_URL } from "../../../constants";
import { TokenInfo } from "../../../models/login/token-info.model";
import { AuthService } from "../../auth/auth.service";
import { LocalStoreService } from "../local-store/local-store.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

	constructor(
		public localStore: LocalStoreService,
		private authService: AuthService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		//console.log('Token intercept', request.url);
		const token = this.localStore.getToken();
		request = this.addToken(request, token);

		return next.handle(request).pipe(catchError(error => {
			if (error instanceof HttpErrorResponse && error.status === 401 && request.url != BASE_URL + 'api/logout/') {
				return this.handle401Error(request, next);
			} else {
				return throwError(error);
			}
		}));
	}

	private isRefreshing = false;
	private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

	private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
		console.log('handle401error');

		if (!this.isRefreshing) {
			console.log('not refreshing');
			this.isRefreshing = true;
			this.refreshTokenSubject.next(null);

			return this.authService.refreshToken().pipe(
				switchMap((loginInfo: TokenInfo) => {
					console.log('refreshed');
					this.localStore.updateToken(loginInfo);

					this.isRefreshing = false;
					this.refreshTokenSubject.next(loginInfo.Token);
					return next.handle(this.addToken(request, loginInfo.Token));
				}),
				catchError(this.handleError<any>())
			);

		} else {
			console.log('refreshing');
			return this.refreshTokenSubject.pipe(
				filter(token => token != null),
				take(1),
				switchMap(jwt => {
					return next.handle(this.addToken(request, jwt));
				}));
		}
	}

	private handleError<T>() {
		return (error: any): Observable<T> => {
			console.log("Refresh error");
			debugger;
			this.isRefreshing = false;
			return throwError(error);
		};
	}

	private addToken(request: HttpRequest<any>, token: string) {
		if (token)
			return request.clone({
				setHeaders: {
					'Authorization': token
				},
				withCredentials: true
			});
		else
			return request.clone({
				withCredentials: true
			});
	}
}
